import { vuexHandbook } from '@/store/composition/handbook'
import { WindingDirectionApi } from '@/api/handbook/position/WindingDirection/WindingDirectionApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: WindingDirectionApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
